import { plainToClass } from "class-transformer";

import { FormTemplatePropertyInfo } from './form-template-property-info';

export class FormTemplateInstancesConfig {
    // Properties.
    private formTemplateProperties: FormTemplatePropertyInfo[];
    private selectedGridFieldId: number = null;
    private commandColumnPostion: string;

    // Constructor.
    public constructor(formTemplateProperties: FormTemplatePropertyInfo[], selectedGridFieldId: number = null, commandColumnPostion: string = null) {
        this.formTemplateProperties = formTemplateProperties;
        this.selectedGridFieldId = selectedGridFieldId;
        this.commandColumnPostion = commandColumnPostion;
    }

    // Getter methods.
    public get FormTemplateProperties(): FormTemplatePropertyInfo[] {
        return this.formTemplateProperties;
    }
    public get SelectedFormTemplateProperties(): FormTemplatePropertyInfo[] {
        let selectedProperties: FormTemplatePropertyInfo[] = this.formTemplateProperties != null ? this.formTemplateProperties.filter(p => p.isSelected) : [];
        return selectedProperties;
    }
    public get SelectedGridFieldId(): number {
        return this.selectedGridFieldId;
    }

    public get CommandColumnPostion(): string {
        return this.commandColumnPostion || 'right';
    }

    // Methods.
    public toJsonString(): string {
        let jsonString: string = JSON.stringify(this);
        return jsonString;
    }

    // Static methods.
    public static fromJsonString(jsonString: string): FormTemplateInstancesConfig {
        let configObject: object = (jsonString != null) && (jsonString.trim() != '') ? JSON.parse(jsonString) : null;
        let config: FormTemplateInstancesConfig = plainToClass(FormTemplateInstancesConfig, configObject);
        return config;
    }
}
